// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    PM_USERS_RESET_PASSWORD_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    resetPasswordPMUserResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* resetUserPassword({ payload }) {
    try {
        let QUERY = `
            mutation resetUserPassword ($id: Int!) {
                result: resetUserPassword (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if(data?.result){
            yield put(resetPasswordPMUserResult({ result: data?.result }))
        }else {
            yield put(resetPasswordPMUserResult({ error: true }))
        }

    } catch (exc) {
        yield put(resetPasswordPMUserResult({ error: true }))
         ExceptionManager(
            exc,
            'Modules/pmUsers/.components/resetUserPassword/redux/saga',
            'resetUserPassword'
        );
    }
}
function* watchMethods() {
    yield takeEvery(PM_USERS_RESET_PASSWORD_REQUEST, resetUserPassword);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}